/* @jsxImportSource react */

import type { PowerSupplyLocalizedProps } from '../PowerSupplyLocalized/PowerSupplyLocalized';
import { PowerSupplyLocalized } from '../PowerSupplyLocalized/PowerSupplyLocalized';

export const ProductCardV2PowerSupply = (props: PowerSupplyLocalizedProps) => (
  <div className="product-card-power-supply p-2 [grid-area:13/2/span_1/span_1]">
    <PowerSupplyLocalized {...props} />
  </div>
);
